import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldOff, MessageCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export const DISABLED_INFO = {
    title: 'CUENTA INHABILITADA',
    message: 'Su cuenta se encuentra actualmente inhabilitada. Para obtener más información, comuníquese con nuestro departamento de soporte.',
    whatsapp: '+44 7400 757168',
    whatsapp_url: 'https://wa.me/447400757168',
};

export const AccountDisabledNotice = ({ info = DISABLED_INFO, onBack }) => (
    <div className="w-full max-w-md mx-auto rounded-3xl bg-slate-900/80 border border-red-500/30 p-8 text-center space-y-6 shadow-2xl" data-testid="account-disabled-notice">
        <div className="mx-auto w-16 h-16 rounded-2xl bg-red-500/15 border border-red-500/30 flex items-center justify-center">
            <ShieldOff className="w-8 h-8 text-red-400" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-extrabold tracking-[0.12em] text-red-400" data-testid="account-disabled-title">{info.title}</h1>
        <p className="text-slate-200 text-sm sm:text-base leading-relaxed" data-testid="account-disabled-message">{info.message}</p>
        <p className="text-slate-400 text-sm">WhatsApp de soporte: <span className="text-white font-semibold" data-testid="account-disabled-whatsapp">{info.whatsapp}</span></p>
        <a href={info.whatsapp_url} target="_blank" rel="noreferrer" className="block" data-testid="account-disabled-whatsapp-btn">
            <Button className="w-full h-12 bg-[#25D366] hover:bg-[#1ebe5b] text-[#0b1a12] font-bold text-base">
                <MessageCircle className="w-5 h-5 mr-2" /> Contactar por WhatsApp
            </Button>
        </a>
        {onBack && (
            <button type="button" onClick={onBack} className="text-xs text-slate-500 hover:text-slate-300 inline-flex items-center gap-1" data-testid="account-disabled-back">
                <ArrowLeft className="w-3 h-3" /> Volver al inicio de sesión
            </button>
        )}
    </div>
);

const AccountDisabledPage = () => {
    const navigate = useNavigate();
    useEffect(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    }, []);
    return (
        <div className="min-h-screen bg-[#060b16] flex items-center justify-center px-4 py-10" data-testid="account-disabled-page">
            <AccountDisabledNotice onBack={() => navigate('/login', { replace: true })} />
        </div>
    );
};

export default AccountDisabledPage;
